import { Component, Inject, OnInit } from '@angular/core';
import { ContractService } from '../../../services/contract_service.service';
import { Contract } from 'src/app/models/contract.model';
import { ContractComponent } from '../../contract/contract.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogClose } from '@angular/material/dialog';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'customer-contract-dialog',
    templateUrl: './customer_contract_dialog.component.html',
    styleUrls: ['./customer_contract_dialog.component.scss'],
    imports: [MatProgressBar, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIconButton, MatIcon, MatButton, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatDialogClose, DatePipe]
})
export class CustomerContractDialogComponent implements OnInit {

    displayedColumns: string[] = ['updateDate', 'signed', 'actions'];
    contracts: Contract[] = [];
    loading = true;
    errorMessage: string | null = null;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { id: string },
        private contractService: ContractService,
        public dialog: MatDialog,
    ) {}

    ngOnInit(): void {
        this.load();
    }

    load(): void {
        this.loading = true;
        this.errorMessage = null;

        this.contractService.getAll([], new Map([['userId', this.data.id]]))
            .subscribe(response => {
            this.contracts = response;
            this.loading = false;
        }, (error) => {
            this.loading = false;
            this.errorMessage = error;
        });
    }

    readContract(contractId: string): void {
        this.dialog.open(ContractComponent, {data: {contractId}});
    }
}
